import { render } from "./Apoyo.vue?vue&type=template&id=62b12cfa"
import script from "./Apoyo.vue?vue&type=script&lang=js"
export * from "./Apoyo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\esteb\\Desktop\\PlantillaEsteban\\fronted-plantilla\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__